import { useEffect, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import Layout from '../../components/Layout'
import { CHANGE_SUPPLIERS_PAGE } from '../../store/types'
import PagnationComponent from '../../components/PagnationComponent'
import { Button, Container, Typography } from '@mui/material'
import { getAllSuppliers } from '../../store/actions/supplierAction'
import SearchSupplier from '../../components/supplier/SearchSupplier'
import SupplierInfos from '../../components/supplier/SupplierInfos'
import { checkUserRole } from '../../common/checkUserRole'
import { roleListId, roleType } from '../../config/roleList'

const Suppliers = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const supplierState = useSelector((state) => state.supplier)
    const { suppliers, pages, page, count, keyword } = supplierState
    const { userInfo } = useSelector((state) => state.auth)
    const { roleList } = useSelector((state) => state.user)

    const pageNumber = page || 1
    useEffect(() => {
        dispatch(getAllSuppliers(keyword, pageNumber))
    }, [dispatch, keyword, pageNumber])

    const changePage = useCallback(
        (page) => {
            dispatch({ type: CHANGE_SUPPLIERS_PAGE, payload: page })
        },
        [dispatch]
    )
    return (
        <Layout>
            <Container>
                <Button
                    color="info"
                    variant="outlined"
                    onClick={() =>
                        checkUserRole(
                            userInfo,
                            roleList,
                            roleListId.SUPPLIER,
                            roleType.CREATE
                        )
                            ? navigate(`/addsupplier`)
                            : alert('Not Permit User')
                    }
                >
                    Add New Supplier
                </Button>
                <SearchSupplier displayKeyword={keyword} />
                <Typography
                    variant="body2"
                    gutterBottom
                    style={{ paddingBottom: '10px', paddingTop: '10px' }}
                >
                    Count: {count}
                </Typography>
                {suppliers && <SupplierInfos suppliers={suppliers} />}
                <PagnationComponent
                    page={pageNumber}
                    pages={pages}
                    func={changePage}
                />
            </Container>
        </Layout>
    )
}

export default Suppliers
